function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2160",
  "data-name": "Rectangle 2160",
  width: 970,
  height: 240,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3206",
  "data-name": "Group 3206",
  transform: "translate(-234 -2165)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1271",
  "data-name": "Path 1271",
  d: "M80.271,71c-10.354,0-18.9,3.456-25.39,10.271C40.181,96.7,41.315,123.817,41.37,124.964l0,73.643c0,43.757-39.678,44.261-41.367,44.261v5.91c.473,0,47.276-.573,47.276-50.171V124.822c-.015-.4-1.058-25.912,11.9-39.489,5.333-5.59,12.431-8.424,21.1-8.424,8.773,0,15.811,2.624,20.917,7.8,10.318,10.46,11.272,28.941,11.094,41.931l-.012.845c-.236,16.969-.533,38.087,13.07,48.4,9.535,7.233,24.022,7.84,44.288,1.854l-1.672-5.667c-18.083,5.338-31.222,5.038-39.044-.9-11.224-8.511-10.95-27.973-10.732-43.611l.012-.847c.194-14.051-.923-34.125-12.8-46.161C99.137,74.217,90.685,71,80.271,71Z",
  transform: "translate(280 2148.336)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("g", {
  id: "_3",
  "data-name": 3,
  transform: "translate(447.111 2250.59)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1262",
  "data-name": "Path 1262",
  d: "M166.536,152.218l53.69-13.226,2.214,9.429-45.2,11.655-9.314-3.683Z",
  transform: "translate(-87.609 -69.795)",
  fill: "#f5f8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1263",
  "data-name": "Path 1263",
  d: "M142.5,152.108l33.341-8.1,3.519,7.961-26.722,5.975-9.439-3.868Z",
  transform: "translate(-99.082 -67.401)",
  fill: "#f5f8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1264",
  "data-name": "Path 1264",
  d: "M115.77,145.085c1.6-.145,33.551-7.759,33.551-7.759l1.111,4.734-27.382,6.557-6.322-1.9Z",
  transform: "translate(-111.844 -70.591)",
  fill: "#f5f8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1265",
  "data-name": "Path 1265",
  d: "M181.492,183.054h0a12.493,12.493,0,0,1-12.313-9.661l-12.524-52.83a12.574,12.574,0,0,1,9.321-15.117l45.282-10.738,18.321,77.267L184.3,182.714A12.518,12.518,0,0,1,181.492,183.054Zm26.476-83.007L167,109.761a8.135,8.135,0,0,0-6.032,9.78l12.525,52.828a8.078,8.078,0,0,0,7.962,6.252h0a7.986,7.986,0,0,0,1.82-.22l40.969-9.714Z",
  transform: "translate(-92.488 -90.936)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1266",
  "data-name": "Path 1266",
  d: "M157.688,177.334a15.089,15.089,0,0,1-14.963-11.391L134.534,131.4c-1.9-8.012,3.326-16.138,11.648-18.11l21.384-5.072,1.022,4.314L147.206,117.6c-5.946,1.412-9.7,7.145-8.359,12.776l8.192,34.55c1.333,5.633,7.26,9.067,13.2,7.663l21.381-5.07,1.024,4.313-21.382,5.07A16,16,0,0,1,157.688,177.334Z",
  transform: "translate(-103.072 -84.487)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1267",
  "data-name": "Path 1267",
  d: "M152.673,150.268a2.216,2.216,0,0,1-2.172-1.706l-5.3-22.371a2.216,2.216,0,0,1,4.313-1.022l5.3,22.375a2.217,2.217,0,0,1-1.644,2.665A2.14,2.14,0,0,1,152.673,150.268Z",
  transform: "translate(-97.825 -77.209)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1268",
  "data-name": "Path 1268",
  d: "M157.621,149.1a2.213,2.213,0,0,1-2.173-1.706l-5.305-22.371A2.217,2.217,0,0,1,154.456,124l5.305,22.374a2.214,2.214,0,0,1-1.647,2.665A2.023,2.023,0,0,1,157.621,149.1Z",
  transform: "translate(-95.464 -77.77)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1269",
  "data-name": "Path 1269",
  d: "M151.277,145.119l-25.7,6.087a6.464,6.464,0,0,1-2.983-12.578l25.7-6.085a2.221,2.221,0,0,0-1.025-4.323l-25.7,6.1c-4.553,1.093-9.9,5.6-8.095,13.112,1.718,7.152,7.907,9.336,13.127,8.081l25.686-6.088a2.211,2.211,0,1,0-1.008-4.307Z",
  transform: "translate(-113.113 -74.968)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1270",
  "data-name": "Path 1270",
  d: "M212.014,179.441a2.214,2.214,0,0,1-2.155-1.709L190.429,94.876a2.216,2.216,0,1,1,4.315-1.012l19.429,82.855a2.215,2.215,0,0,1-1.652,2.662A2.139,2.139,0,0,1,212.014,179.441Z",
  transform: "translate(-76.231 -92.154)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3192",
  "data-name": "Group 3192",
  transform: "translate(844.424 2253.947)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1285",
  "data-name": "Path 1285",
  d: "M218.184,114.178a8.428,8.428,0,0,1-3.586-.835,6.406,6.406,0,0,1-2.331-9.956,8.8,8.8,0,0,1,4.983-3.123l24.882-5.837,1.014,4.314-24.881,5.837a4.427,4.427,0,0,0-2.491,1.519,2,2,0,0,0,.764,3.265,4.445,4.445,0,0,0,2.9.251l25.1-5.884,1.013,4.314-25.1,5.884A9.314,9.314,0,0,1,218.184,114.178Z",
  transform: "translate(-210.794 -94.427)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3193",
  "data-name": "Group 3193",
  transform: "translate(853.111 2290.984)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1286",
  "data-name": "Path 1286",
  d: "M224.092,139.244c-3.491-.049-6.532-2.114-7.257-5.228-.883-3.766,1.941-7.657,6.3-8.683l24.885-5.837,1.011,4.317-24.887,5.834c-1.941.457-3.308,1.994-2.99,3.357s2.235,2.138,4.178,1.677l25.092-5.882,1.011,4.314L226.338,139A9.129,9.129,0,0,1,224.092,139.244Z",
  transform: "translate(-216.674 -119.496)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_1272",
  "data-name": "Path 1272",
  d: "M477.355,39.636c-.473,0-47.276.606-47.276,52.939v77.072c.016.394,1.055,25.794-11.865,39.335-5.338,5.595-12.447,8.431-21.131,8.431-31.417,0-31.816-33.486-32.008-49.58l-.009-.83c-.149-12.893-.4-34.472-13.8-46.112-7.669-6.662-18.6-9.13-32.458-7.332a8.079,8.079,0,0,0-4,1.486l3.277,4.917a2.442,2.442,0,0,1,1.479-.542c12.123-1.569,21.486.425,27.827,5.935,11.4,9.9,11.631,29.818,11.77,41.716l.01.836c.2,16.584.659,55.417,37.916,55.417,10.373,0,18.927-3.457,25.424-10.278,14.666-15.4,13.533-42.4,13.478-43.543l0-76.928c0-46.347,39.683-47.024,41.373-47.03Z",
  transform: "translate(683.283 2133.363)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3186",
  "data-name": "Group 3186",
  transform: "translate(887.158 2292.785)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1279",
  "data-name": "Path 1279",
  d: "M239.719,131.787l46.709-11.072,2.13,9.415L241.63,140.383Z",
  transform: "translate(-239.719 -120.715)",
  fill: "#f5f8fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3187",
  "data-name": "Group 3187",
  transform: "translate(934.314 2281.926)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1280",
  "data-name": "Path 1280",
  d: "M271.638,121.563l35.2-8.2-5.226,9.222L273.6,129.654Z",
  transform: "translate(-271.638 -113.365)",
  fill: "#f5f8fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3191",
  "data-name": "Group 3191",
  transform: "translate(966.172 2254.775)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1284",
  "data-name": "Path 1284",
  d: "M293.2,102.788l33.277-7.8-2.772,6.776-29.025,6.619Z",
  transform: "translate(-293.201 -94.987)",
  fill: "#f5f8fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3195",
  "data-name": "Group 3195",
  transform: "translate(871.053 2232.207)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1288",
  "data-name": "Path 1288",
  d: "M245.473,162.889,228.818,91.871l51.839-12.159,16.659,71.02ZM234.145,95.174l14.632,62.39,43.211-10.133L277.359,85.039Z",
  transform: "translate(-228.818 -79.712)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3196",
  "data-name": "Group 3196",
  transform: "translate(923.158 2230.918)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1289",
  "data-name": "Path 1289",
  d: "M279.012,147.933,278,143.621,299.4,138.6a11.3,11.3,0,0,0,6.951-4.824,10.161,10.161,0,0,0,1.438-7.931l-8.106-34.568a10.186,10.186,0,0,0-4.813-6.464,11.323,11.323,0,0,0-8.374-1.229L265.1,88.6l-1.009-4.314,21.393-5.019A15.751,15.751,0,0,1,297.116,81,14.565,14.565,0,0,1,304,90.267l8.1,34.569a14.566,14.566,0,0,1-2.039,11.357,15.71,15.71,0,0,1-9.656,6.724Z",
  transform: "translate(-264.086 -78.839)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3197",
  "data-name": "Group 3197",
  transform: "translate(960.975 2243.094)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1290",
  "data-name": "Path 1290",
  d: "M295.83,114.674a2.217,2.217,0,0,1-.474-4.375l25.712-6.028a6.464,6.464,0,1,0-2.952-12.587L292.4,97.715a2.216,2.216,0,0,1-1.013-4.314l25.71-6.031a10.895,10.895,0,1,1,4.977,21.214l-25.709,6.029A2.032,2.032,0,0,1,295.83,114.674Z",
  transform: "translate(-289.683 -87.081)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3198",
  "data-name": "Group 3198",
  transform: "translate(938.07 2251.313)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1291",
  "data-name": "Path 1291",
  d: "M281.613,119.462a2.221,2.221,0,0,1-2.127-1.711l-5.246-22.384a2.213,2.213,0,1,1,4.31-1.012l5.252,22.384a2.213,2.213,0,0,1-1.652,2.662A2.238,2.238,0,0,1,281.613,119.462Z",
  transform: "translate(-274.18 -92.644)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3199",
  "data-name": "Group 3199",
  transform: "translate(945.379 2249.598)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1292",
  "data-name": "Path 1292",
  d: "M286.563,118.3a2.218,2.218,0,0,1-2.126-1.711l-5.251-22.382A2.214,2.214,0,1,1,283.5,93.2l5.255,22.384a2.22,2.22,0,0,1-1.653,2.664A2.384,2.384,0,0,1,286.563,118.3Z",
  transform: "translate(-279.127 -91.483)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3200",
  "data-name": "Group 3200",
  transform: "translate(917.893 2225.457)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1293",
  "data-name": "Path 1293",
  d: "M282.167,162.433a2.217,2.217,0,0,1-2.156-1.712L260.581,77.864a2.215,2.215,0,1,1,4.314-1.011l19.431,82.855a2.215,2.215,0,0,1-1.65,2.664A2.241,2.241,0,0,1,282.167,162.433Z",
  transform: "translate(-260.522 -75.143)",
  fill: "#d5dae0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3205",
  "data-name": "Group 3205",
  transform: "translate(64.756 2000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1321",
  "data-name": "Path 1321",
  d: "M567.369,979.525a2.5,2.5,0,0,1-.961-4.816l10.406-4.309a2.5,2.5,0,0,1,1.915,4.625l-10.405,4.309A2.491,2.491,0,0,1,567.369,979.525Z",
  transform: "translate(47.349 -671.616)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1322",
  "data-name": "Path 1322",
  d: "M375.387,1059.062a2.5,2.5,0,0,1-.961-4.815l10.405-4.311a2.5,2.5,0,0,1,1.916,4.625l-10.405,4.309A2.5,2.5,0,0,1,375.387,1059.062Z",
  transform: "translate(217.365 -742.054)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1323",
  "data-name": "Path 1323",
  d: "M1294.921,678.154a2.5,2.5,0,0,1-.959-4.815l10.405-4.309a2.5,2.5,0,0,1,1.916,4.624l-10.405,4.31A2.522,2.522,0,0,1,1294.921,678.154Z",
  transform: "translate(-596.958 -404.728)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1324",
  "data-name": "Path 1324",
  d: "M1102.927,757.688a2.5,2.5,0,0,1-.961-4.815l10.406-4.31a2.5,2.5,0,0,1,1.916,4.626l-10.406,4.309A2.493,2.493,0,0,1,1102.927,757.688Z",
  transform: "translate(-426.933 -475.162)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1325",
  "data-name": "Path 1325",
  d: "M577.772,757.673a2.482,2.482,0,0,1-.957-.192l-10.406-4.309a2.5,2.5,0,1,1,1.916-4.624l10.405,4.309a2.5,2.5,0,0,1-.958,4.816Z",
  transform: "translate(47.349 -475.148)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1326",
  "data-name": "Path 1326",
  d: "M385.777,678.144a2.5,2.5,0,0,1-.957-.192l-10.406-4.31a2.5,2.5,0,0,1,1.915-4.624l10.406,4.31a2.5,2.5,0,0,1-.958,4.816Z",
  transform: "translate(217.375 -404.719)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1327",
  "data-name": "Path 1327",
  d: "M1305.321,1059.047a2.529,2.529,0,0,1-.957-.191l-10.4-4.31a2.5,2.5,0,0,1,1.916-4.625l10.4,4.31a2.5,2.5,0,0,1-.959,4.815Z",
  transform: "translate(-596.957 -742.041)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1328",
  "data-name": "Path 1328",
  d: "M1113.34,979.525a2.5,2.5,0,0,1-.958-.192l-10.405-4.309a2.5,2.5,0,0,1,1.915-4.625l10.406,4.309a2.5,2.5,0,0,1-.958,4.816Z",
  transform: "translate(-426.94 -671.616)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1329",
  "data-name": "Path 1329",
  d: "M977.012,1115.853a2.5,2.5,0,0,1-2.314-1.545l-4.312-10.405a2.5,2.5,0,1,1,4.624-1.916l4.31,10.405a2.5,2.5,0,0,1-2.31,3.461Z",
  transform: "translate(-311.607 -786.951)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1330",
  "data-name": "Path 1330",
  d: "M1056.549,1307.832a2.506,2.506,0,0,1-2.313-1.545l-4.311-10.405a2.5,2.5,0,0,1,4.625-1.915l4.31,10.4a2.5,2.5,0,0,1-2.311,3.461Z",
  transform: "translate(-382.045 -956.963)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1331",
  "data-name": "Path 1331",
  d: "M675.65,388.286a2.5,2.5,0,0,1-2.313-1.546l-4.31-10.405a2.5,2.5,0,0,1,4.626-1.915l4.31,10.405a2.5,2.5,0,0,1-2.312,3.461Z",
  transform: "translate(-44.728 -142.63)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1332",
  "data-name": "Path 1332",
  d: "M755.181,580.276a2.505,2.505,0,0,1-2.315-1.546l-4.309-10.405a2.5,2.5,0,1,1,4.624-1.915l4.312,10.406a2.5,2.5,0,0,1-2.312,3.46Z",
  transform: "translate(-115.159 -312.652)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1331-2",
  "data-name": "Path 1331",
  d: "M675.65,388.286a2.5,2.5,0,0,1-2.313-1.546l-4.31-10.405a2.5,2.5,0,0,1,4.626-1.915l4.31,10.405a2.5,2.5,0,0,1-2.312,3.461Z",
  transform: "translate(1031.346 -382.544) rotate(90)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1332-2",
  "data-name": "Path 1332",
  d: "M755.181,580.276a2.505,2.505,0,0,1-2.315-1.546l-4.309-10.405a2.5,2.5,0,1,1,4.624-1.915l4.312,10.406a2.5,2.5,0,0,1-2.312,3.46Z",
  transform: "translate(-102.159 -281.652)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1333",
  "data-name": "Path 1333",
  d: "M750.86,1115.855a2.506,2.506,0,0,1-2.311-3.462l4.31-10.406a2.5,2.5,0,0,1,4.625,1.916l-4.309,10.406A2.509,2.509,0,0,1,750.86,1115.855Z",
  transform: "translate(-115.151 -786.951)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1334",
  "data-name": "Path 1334",
  d: "M671.335,1307.835a2.506,2.506,0,0,1-2.311-3.462l4.309-10.405a2.5,2.5,0,0,1,4.626,1.915l-4.311,10.406A2.507,2.507,0,0,1,671.335,1307.835Z",
  transform: "translate(-44.726 -956.965)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1335",
  "data-name": "Path 1335",
  d: "M1052.214,388.286a2.506,2.506,0,0,1-2.311-3.462l4.311-10.405a2.5,2.5,0,0,1,4.625,1.916l-4.31,10.405A2.5,2.5,0,0,1,1052.214,388.286Z",
  transform: "translate(-382.024 -142.628)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1336",
  "data-name": "Path 1336",
  d: "M972.7,580.267a2.5,2.5,0,0,1-2.312-3.461L974.7,566.4a2.5,2.5,0,1,1,4.623,1.916l-4.31,10.405A2.5,2.5,0,0,1,972.7,580.267Z",
  transform: "translate(-311.606 -312.643)",
  fill: "#00a0af"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_49",
  "data-name": "Ellipse 49",
  cx: 3,
  cy: 3,
  r: 3,
  transform: "translate(277 2391)",
  fill: "#d5dae0"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_50",
  "data-name": "Ellipse 50",
  cx: 3,
  cy: 3,
  r: 3,
  transform: "translate(915 26)",
  fill: "#d5dae0"
});

var SvgIllustrationError404 = function SvgIllustrationError404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration_-_Error_404",
    "data-name": "Illustration - Error 404",
    width: 970,
    height: 240,
    viewBox: "0 0 970 240",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustrationError404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Illustration_Error_404.1a604466.svg";
export { ForwardRef as ReactComponent };